import { useState } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { PinFrequency } from "@/Common/Models/UI/Enums";
import { ComboBoxDropDownItem } from "../Inputs/Combobox";
import { ComboBoxControl } from "../Inputs/ComboboxControl";

import styles from "./PinFrequencyControl.module.scss";

interface IPinFrequencyControlProps {
    initialPinFrequency: PinFrequency;
    className?: string;
    onChange: (pinFrequency: PinFrequency) => void;
}

export function PinFrequencyControl(props: IPinFrequencyControlProps): JSX.Element {
    const { getText } = useTranslation();

    const [currentPinFrequency, setCurrentPinFrequency] = useState(props.initialPinFrequency);

    const items = Immutable.List([
        new ComboBoxDropDownItem(String(PinFrequency.Always), getText("DocumentSigningPinOptions_AlwaysLabel")),
        new ComboBoxDropDownItem(String(PinFrequency.EverySession), getText("DocumentSigningPinOptions_EverySessionLabel")),
        new ComboBoxDropDownItem(String(PinFrequency.EveryDay), getText("DocumentSigningPinOptions_EveryDayLabel")),
        new ComboBoxDropDownItem(String(PinFrequency.Weekly), getText("DocumentSigningPinOptions_WeeklyLabel")),
        new ComboBoxDropDownItem(String(PinFrequency.Monthly), getText("DocumentSigningPinOptions_MonthlyLabel")),
        new ComboBoxDropDownItem(String(PinFrequency.Never), getText("DocumentSigningPinOptions_NeverLabel"))
    ]);

    return (
        <ComboBoxControl
            id="pinFrequencyComboboxControl"
            selectedCode={String(currentPinFrequency)}
            items={items}
            onChange={newValue => {
                const valueWithType = Number(newValue) as unknown as PinFrequency;
                setCurrentPinFrequency(valueWithType);
                props.onChange(valueWithType);
            }}
            className={props.className ?? styles.defaultComboBox}
        />
    );
}
